import { render, staticRenderFns } from "./ArrivedOrdersPage.vue?vue&type=template&id=467e1e82&scoped=true&"
import script from "./ArrivedOrdersPage.vue?vue&type=script&lang=js&"
export * from "./ArrivedOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e1e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467e1e82')) {
      api.createRecord('467e1e82', component.options)
    } else {
      api.reload('467e1e82', component.options)
    }
    module.hot.accept("./ArrivedOrdersPage.vue?vue&type=template&id=467e1e82&scoped=true&", function () {
      api.rerender('467e1e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/ArrivedOrdersPage.vue"
export default component.exports